import { createAction, props } from '@ngrx/store';
import { MdaRevenueHeadDetailReducerInitialState } from '../reducers/admin-mda-revenue-head-detail.reducer';

const prefix = '[Admin-mda-revenue-head-detail]';

export const setStateAction = createAction(
  `${prefix} set state`,
  props<Partial<MdaRevenueHeadDetailReducerInitialState>>(),
);

export const setQueryAction = createAction(
  `${prefix} set query`,
  props<
    Partial<{
      minDate: string;
      maxDate: string;
      month: number;
      year: number;
    }>
  >(),
);

export const resetQueryAction = createAction(
  `${prefix} reset query`,
  props<any>(),
);
